import { ROLE_COLOURS, ROLE_LABELS } from "@/lib/constants";

export default function RoleChip({ role, className = "" }) {
    const colour = ROLE_COLOURS[role] || "#6F6A64";
    const label = ROLE_LABELS[role] || role;
    return (
        <span
            className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full ${className}`}
            style={{
                background: `${colour}14`,
                color: colour,
                border: `1px solid ${colour}33`,
            }}
        >
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: colour }} />
            {label}
        </span>
    );
}
